export const freeProxyInitialState = {
  freeProxies: [],
  cities: [],
  freeProxiesForExport: [],
  isFreeProxiesForExportLoaded: false,
  paginationData: null,
  isLoading: false,
  isOpenDropDown: false,
  isProxyLoaded: false,
  clearSelectedCountry: false,
  isFirstRender: true,
};
